import type { AxiosResponse } from 'axios';

import api from '../axios';
import type {
  propsApiQuoteDetail,
  propsApiQuoteProduct,
  propsApiQuotesResponse,
} from '../interfaces';

export function getQuotesRequest(
  uf?: string | null,
): Promise<AxiosResponse<propsApiQuotesResponse>> {
  const qs = uf ? `?uf=${encodeURIComponent(uf)}` : '';
  return api.get(`/v1/cotacoes${qs}`);
}

export function getQuoteDetailRequest(
  product: propsApiQuoteProduct,
  uf?: string | null,
  range = 30,
): Promise<AxiosResponse<propsApiQuoteDetail>> {
  const qs = new URLSearchParams();
  if (uf) qs.set('uf', uf);
  qs.set('range', String(range));
  return api.get(`/v1/cotacoes/${product}?${qs.toString()}`);
}

export function getWeatherRequest(params: {
  lat?: number;
  lon?: number;
  city?: string;
}) {
  const qs = new URLSearchParams();
  if (params.lat != null) qs.set('lat', String(params.lat));
  if (params.lon != null) qs.set('lon', String(params.lon));
  if (params.city) qs.set('city', params.city);
  const tail = qs.toString();
  return api.get(`/v1/cotacoes/weather${tail ? `?${tail}` : ''}`);
}

export function getDashboardSummary() {
  return api.get('/v1/dashboard/summary');
}
